
import { PropsWithChildren } from 'react';
import { ProductCategoryType } from '../../../../common/enums';
import OrderQueue from '../../components/OrderQueue';
import StationHeader from '../../components/StationHeader';

interface PrimaryStationProps {
  stationId: number
}

export default function PrimaryStation({
  stationId,
  children
}: PropsWithChildren<PrimaryStationProps>) {

  return (
    <OrderQueue
      categories={[ProductCategoryType.HotCoffee, ProductCategoryType.Tea]}
      stationId={stationId}
      header={() => <StationHeader />}
    >
      {children}
    </OrderQueue>
  )
}
